<template>
  <div class="participant-tab">
    <div class="tab-header">
      <el-button v-if="canEdit" type="primary" size="small" @click="showAddDialog = true">
        참여자 추가
      </el-button>
    </div>

    <el-table :data="participants || []" stripe>
      <el-table-column prop="employee_name" label="이름" width="120" />
      <el-table-column prop="department_name" label="부서" width="120" />
      <el-table-column prop="role" label="역할" width="120">
        <template #default="{ row }">
          <el-tag size="small">{{ getRoleDisplay(row.role) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="remarks" label="비고" />
      <el-table-column v-if="canEdit" label="작업" width="80">
        <template #default="{ row }">
          <el-button size="small" type="danger" link @click="removeParticipant(row)">
            삭제
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-empty v-if="participants.length === 0" description="등록된 참여자가 없습니다" />

    <!-- 추가 다이얼로그 -->
    <el-dialog v-model="showAddDialog" title="참여자 추가" width="400px">
      <el-form :model="form" label-width="80px">
        <el-form-item label="직원">
          <el-select v-model="form.employee" placeholder="직원 선택" style="width: 100%">
            <el-option
              v-for="emp in employees"
              :key="emp.id"
              :label="`${emp.get_full_name || emp.username} (${emp.department_name || '-'})`"
              :value="emp.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="역할">
          <el-select v-model="form.role" placeholder="역할 선택" style="width: 100%">
            <el-option label="MD담당" value="MD" />
            <el-option label="자재담당" value="MATERIAL" />
            <el-option label="생산담당" value="PRODUCTION" />
            <el-option label="무역담당" value="TRADE" />
            <el-option label="QC담당" value="QC" />
            <el-option label="기타" value="OTHER" />
          </el-select>
        </el-form-item>
        <el-form-item label="비고">
          <el-input v-model="form.remarks" type="textarea" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="showAddDialog = false">취소</el-button>
        <el-button type="primary" @click="addParticipant">추가</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import axiosInstance from '@/api/axios'

defineProps({
  participants: {
    type: Array,
    default: () => []
  },
  canEdit: {
    type: Boolean,
    default: false
  }
})

defineEmits(['updated'])

const showAddDialog = ref(false)
const employees = ref([])

const form = reactive({
  employee: null,
  role: '',
  remarks: ''
})

const roleDisplayMap = {
  'MD': 'MD담당',
  'MATERIAL': '자재담당',
  'PRODUCTION': '생산담당',
  'TRADE': '무역담당',
  'QC': 'QC담당',
  'OTHER': '기타'
}

const getRoleDisplay = (role) => {
  return roleDisplayMap[role] || role
}

const fetchEmployees = async () => {
  try {
    const response = await axiosInstance.get('employees/')
    employees.value = response.data.results || response.data
  } catch (error) {
    console.error('Failed to fetch employees:', error)
  }
}

const addParticipant = () => {
  // TODO: API 호출
  ElMessage.info('참여자 추가 기능은 구현 예정입니다.')
  showAddDialog.value = false
}

const removeParticipant = async () => {
  try {
    await ElMessageBox.confirm('이 참여자를 삭제하시겠습니까?', '확인')
    // TODO: API 호출
    ElMessage.info('참여자 삭제 기능은 구현 예정입니다.')
  } catch {
    // 취소 시 무시
  }
}

onMounted(() => {
  fetchEmployees()
})
</script>

<style scoped>
.participant-tab {
  padding: 20px;
}

.tab-header {
  margin-bottom: 15px;
}
</style>
